import React from 'react';
import SearchBar from './SearchBar';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <span className="hero-kicker">El directorio #1 de proveedores para XV años en México</span>
        <h1>Todo para la fiesta de XV años que siempre soñaste</h1>
        <p>
          Compara salones, vestidos, academias de baile, barras, entretenimiento, maquillistas,
          limosinas y cabinas fotográficas en un solo lugar. Sin vueltas, sin sorpresas.
        </p>
        <SearchBar />
        <div className="hero-stats">
          <div><strong>+1,200</strong><span>Proveedores</span></div>
          <div><strong>+30</strong><span>Ciudades</span></div>
          <div><strong>+15,000</strong><span>Familias atendidas</span></div>
        </div>
      </div>
    </section>
  );
}
